import React, { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useLocation, useParams } from 'react-router-dom';

import { AuthProvider } from './Auth';
import { CartProvider } from './Cart';
import { ResizeProvider } from './Resize';

declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage: (message: string) => void;
    };
  }
}

interface IParams {
  [key: string]: string;
}

const AppProvider: React.FC = ({ children }) => {
  const location = useLocation();
  const params = useParams<IParams>();

  useEffect(() => {
    if (window.ReactNativeWebView) {
      const data = {
        stausBarColor: '#f4f0ec',
      };

      switch (location.pathname) {
        case '/':
        case '/meus-ingressos/proximos':
        case '/meus-ingressos/realizados':
        case '/meus-ingressos/cancelados':
        case '/buscar-eventos':
        case `/meus-ingressos/${params.slug}`:
          data.stausBarColor = '#f4f0ec';
          break;
        case '/login':
        case `/eventos/${params.slug}`:
          data.stausBarColor = '#ff6900';
          break;
        case '/cadastro':
        case '/cadastro/verificar-conta':
        case '/recuperar-senha':
        case `/alterar-senha/${params.token}`:
        case `/eventos/${params.slug}/categorias`:
        case `/eventos/${params.slug}/titularidade`:
        case `/eventos/${params.slug}/resumo`:
          data.stausBarColor = '#ffffff';
          break;
        case '/perfil/meus-dados':
        case '/perfil/compras':
        case '/perfil/seguranca':
        case '/perfil/suporte':
          data.stausBarColor = '#ff7a00';
          break;
        default:
          data.stausBarColor = '#f4f0ec';
          break;
      }

      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  }, [location, params]);

  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_OAUTH_CLIENT_ID as string}
    >
      <ResizeProvider>
        <CartProvider>
          <AuthProvider>{children}</AuthProvider>
        </CartProvider>
      </ResizeProvider>
    </GoogleOAuthProvider>
  );
};

export default AppProvider;
